'use client';

import { SmartIcon } from '@/shared/blocks/common/smart-icon';
import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { cn } from '@/shared/lib/utils';
import { Section } from '@/shared/types/blocks/landing';

export function Features({
  section,
  className,
}: {
  section: Section;
  className?: string;
}) {
  return (
    <section
      id={section.id}
      className={cn('py-16 md:py-24', section.className, className)}
    >
      <div className="container">
        {/* Section Header */}
        <ScrollAnimation>
          <div className="section-header mb-12 max-w-[600px]">
            {section.label && (
              <p className="section-label">{section.label}</p>
            )}
            <h2 className="section-title text-foreground">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-lg font-light text-muted-foreground">
                {section.description}
              </p>
            )}
          </div>
        </ScrollAnimation>

        {/* Features Grid - Demo Style */}
        <ScrollAnimation delay={0.2}>
          <div className="features-grid-demo">
            {section.items?.map((item, idx) => (
              <div className="feature-card-demo" key={idx}>
                {/* Feature Icon Circle */}
                <div className="feature-icon-circle">
                  {item.icon && <SmartIcon name={item.icon as string} size={20} />}
                </div>
                
                {/* Feature Title */}
                <h3 className="mb-3 font-display text-lg font-semibold tracking-wide text-foreground">
                  {item.title}
                </h3>
                
                {/* Feature Description */}
                <p className="text-sm font-light leading-relaxed text-muted-foreground">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
